import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Viewports',
  attributeName: 'viewports',
  validationUrl:'live',
  hiddenJsonComponent:true,
  fields: [
    {
      attributeName: 'ID',
      type: FormInputTypes.SELECT,
      disabled:true,
      label: 'ID',
      required: true,
      helpText: 'Set the id.',
      default:0,
      options: [
        { name: '0-Right', value: '0-Right' },
        { name: '1-Left', value: '1-Left' },
        { name: '2-Top', value: '2-Top' },
        { name: '3-Bottom', value: '3-Bottom' },
        { name: '4-Front', value: '4-Front' },
        { name: '5-Back', value: '5-Back' },
        { name: '6-Front-right', value: '6-Front-right' },
        { name: '7-Back-left', value: '7-Back-left' },
        { name: '8-Back-right', value: '8-Back-right' },
        { name: '9-Front-left', value: '9-Front-left' },
        { name: '10-Front-top', value: '10-Front-top' },
        { name: '11-Front-bottom', value: '11-Front-bottom' },
        { name: '12-Right-top', value: '12-Right-top' },
        { name: '13-Right-bottom', value: '13-Right-bottom' },
        { name: '14-Back-top', value: '14-Back-top' },
        { name: '15-Back-bottom', value: '15-Back-bottom' },
        { name: '16-Left-top', value: '16-Left-top' },
        { name: '17-Left-bottom', value: '17-Left-bottom' },
        { name: '18-Safety', value: '18-Safety' },
      ],
      errorText: '',
    },
    {
      attributeName: 'faceSize',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Face size',
      required: true,
      default:'896',
      helpText: 'Set the face size.',
      errorText: '',
    },
    {
      attributeName: 'offCenter',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Offcenter',
      required: true,
      helpText: 'Set the offcenter.',
      default:'-0.25',
      errorText: '',
    },
    {
      attributeName: 'fallbackID',
      type: FormInputTypes.SELECT,
      label: 'Fallback ID',
      required: true,
      default:"",
      emptyValue:true,
      helpText: 'Set the fallback if needed.',
      options: [
        { name: '0-Right', value: '0-Right' },
        { name: '1-Left', value: '1-Left' },
        { name: '2-Top', value: '2-Top' },
        { name: '3-Bottom', value: '3-Bottom' },
        { name: '4-Front', value: '4-Front' },
        { name: '5-Back', value: '5-Back' },
        { name: '6-Front-right', value: '6-Front-right' },
        { name: '7-Back-left', value: '7-Back-left' },
        { name: '8-Back-right', value: '8-Back-right' },
        { name: '9-Front-left', value: '9-Front-left' },
        { name: '10-Front-top', value: '10-Front-top' },
        { name: '11-Front-bottom', value: '11-Front-bottom' },
        { name: '12-Right-top', value: '12-Right-top' },
        { name: '13-Right-bottom', value: '13-Right-bottom' },
        { name: '14-Back-top', value: '14-Back-top' },
        { name: '15-Back-bottom', value: '15-Back-bottom' },
        { name: '16-Left-top', value: '16-Left-top' },
        { name: '17-Left-bottom', value: '17-Left-bottom' },
        { name: '18-Safety', value: '18-Safety' },
      ],
      errorText: '',
    },
  ]
};
